import React, { useState, useEffect, useMemo } from "react";
import { WalletController } from "../../controllers";
import { walletStore } from "../../stores";
import { BankAccountList } from '../../pages'

const BankAccountListContainer = () => {
    const [loading, setLoading] = useState(false);

    const [limit, setLimit] = useState(50);
    const [filterQuery, setFilterQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const BankAccountListTableQuery = useMemo(() => {
        return `offset=${currentPage + 1}&limit=${limit}&accountType=Business&provider=Kuda`;
    }, [currentPage, limit]);

    const { isLoading, data, isFetching } = WalletController.useGetAllBusinessBankAccounts(
        BankAccountListTableQuery,
        filterQuery,
        searchQuery
    );

    const onLimitChange = (limit) => {
        setLimit(limit);
        setCurrentPage(0);
    };
    return (
        <BankAccountList
            isLoading={isLoading}
            data={data}
            isFetching={isFetching}
            limit={limit}
            onLimitChange={onLimitChange}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
        />
    )
}

export default BankAccountListContainer